import React from 'react';
import styled from 'styled-components';
import sharedStyles from '@rsc/ui-components/styles';
import SupportArticleText from './SupportArticleText';
import SupportIcon from '../../support-icon';

const IconList = styled.div`
  display: inline;
  padding-left: 0;
`;

const IconListItem = styled.div`
  display: flex;
  padding-top: ${sharedStyles.spacing['spacing-1xs']};
  padding-bottom: ${sharedStyles.spacing['spacing-1xs']};
`;

const IconWrapper = styled.div`
  margin-right: 5px;
`;

const IconListTextWrapper = styled.div`
  padding: 0;
  margin-top: auto;
  margin-bottom: auto;

  > p {
    margin: 0;
    vertical-align: center;
  }
`;

function SupportArticleIconList({ section }) {
  return (
    <IconList>
      {section?.listItems?.map(item => {
        return (
          <IconListItem key={`${section._key}`}>
            <IconWrapper>
              <SupportIcon iconType={item.icon} />
            </IconWrapper>
            <IconListTextWrapper>
              <SupportArticleText text={item.text?.text} />
            </IconListTextWrapper>
          </IconListItem>
        );
      })}
    </IconList>
  );
}

export default SupportArticleIconList;
